import { Axios } from "./request";

const API_URL = "usersapi/v1/ticketings/";

export const TICKETING_API = {
  GetMyQuestionsGrid: (search, categoryId, from, size) => {
    return Axios.get(
      `${API_URL}GetMyQuestionsGrid?search=${search}&categoryId=${categoryId}&from=${from}&size=${size}`
    );
  },
  GetAllCategories: () => {
    return Axios.get(`${API_URL}GetAllCategories`);
  },
  AddQuestion: (body) => {
    return Axios.post(`${API_URL}AddQuestion`, body);
  },
  AddQuestionInfo: (body) => {
    return Axios.post(`${API_URL}AddQuestionInfo`, body);
  },
  GetQuestionInfosGrid: (questionId) => {
    return Axios.get(`${API_URL}GetQuestionInfosGrid?questionId=${questionId}`);
  },
};
